import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { CreateTellentApp, TellentApps, TellentAppsResponse } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentAppsHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public fetchApps(): Observable<TellentAppsResponse> {
    return this.httpApi.get('/apps');
  }

  public createApp(data: CreateTellentApp): Observable<{ data: TellentApps }> {
    return this.httpApi.post('/apps', null, data);
  }
}
